module.exports = __webpack_public_path__ + "img/logo_chat.bade8062.png";